import cookieStorage from '../cookie'

// TODO: remove this
export const getCurrentMerchantID = () => {
	const currentMerchantID = cookieStorage.getItem('currentMerchantID')

	return { currentMerchantID }
}
